// "Últimos textos usados" — persistidos en localStorage por usuario (Fase 1, sin DB).

const KEY = 'atlas_edicion_grafica_textos';
const MAX = 8;

export function getUltimosTextos(): string[] {
  try {
    const raw = localStorage.getItem(KEY);
    const arr = raw ? JSON.parse(raw) : [];
    return Array.isArray(arr) ? arr.filter((t) => typeof t === 'string' && t.trim()) : [];
  } catch {
    return [];
  }
}

export function addUltimoTexto(text: string): void {
  const t = text.trim();
  if (!t) return;
  try {
    const cur = getUltimosTextos().filter((x) => x !== t);
    cur.unshift(t);
    localStorage.setItem(KEY, JSON.stringify(cur.slice(0, MAX)));
  } catch {
    /* localStorage bloqueado → no persiste, no rompe */
  }
}
